import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { LoadingButton } from "@mui/lab";
import { alpha, useTheme } from "@mui/material";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

interface WooCheckoutTriggerButtonProps {
  draftItemCount: number;
  loading?: boolean;
  onCheckout: () => void;
  /** Colado à direita de um campo de busca — sem cantos arredondados à esquerda. */
  attached?: boolean;
  /** Bloqueia checkout mesmo com itens no carrinho (ex.: aguardando liberação). */
  disabled?: boolean;
}

/** Botão de finalizar solicitação — desabilitado até haver itens no pedido. */
export function WooCheckoutTriggerButton({
  draftItemCount,
  loading = false,
  onCheckout,
  attached = false,
  disabled = false,
}: WooCheckoutTriggerButtonProps) {
  const theme = useTheme();
  const enabled = draftItemCount > 0 && !disabled;

  return (
    <LoadingButton
      variant="contained"
      disabled={!enabled}
      loading={loading}
      onClick={onCheckout}
      startIcon={attached ? undefined : <ShoppingBagOutlinedIcon sx={{ fontSize: 18 }} />}
      aria-label={
        enabled
          ? `Finalizar solicitação, ${draftItemCount} itens no pedido`
          : "Finalizar solicitação, adicione produtos ao pedido"
      }
      sx={{
        minHeight: 44,
        height: 44,
        width: attached ? "auto" : { xs: "100%", sm: "auto" },
        px: attached ? { xs: 1.25, sm: 1.75 } : 1.5,
        flexShrink: 0,
        whiteSpace: "nowrap",
        textTransform: "none",
        ...mt.button,
        boxShadow: "none",
        bgcolor: enabled ? "success.main" : theme.palette.neutral300.main,
        color: enabled ? "common.white" : theme.palette.neutral600.main,
        ...(attached
          ? {
              borderRadius: 0,
              borderLeft: `1px solid ${alpha(
                enabled ? theme.palette.success.dark : theme.palette.neutral600.main,
                enabled ? 0.35 : 0.2,
              )}`,
            }
          : {}),
        "&:hover": {
          boxShadow: "none",
          bgcolor: enabled ? "success.dark" : theme.palette.neutral300.main,
        },
        "&.Mui-disabled": {
          bgcolor: theme.palette.neutral300.main,
          color: theme.palette.neutral600.main,
          border: attached ? "none" : `1px solid ${alpha(theme.palette.neutral600.main, 0.12)}`,
          ...(attached
            ? {
                borderLeft: `1px solid ${alpha(theme.palette.neutral600.main, 0.2)}`,
              }
            : {}),
        },
      }}
    >
      Finalizar solicitação
    </LoadingButton>
  );
}
